import Box from '@mui/material/Box';
import { useTranslation } from 'react-i18next';

import { EntityType } from '@/core/graphql/generated/types';
import { OWNSO_RELATIONSHIP_TYPE_ID } from '@/pages/HcoProfilePage/sections/HcoAffiliationsSection/_constants/hcoAffiliationSections';

import { AddressSection } from '../../Sections/AddressSection/AddressSection';
import { AffiliationsSection } from '../../Sections/AffiliationsSections/AffiliationsSections';
import { ContactSection } from '../../Sections/ContactSection/ContactSection';
import { HcoIdsSection } from '../../Sections/HcoSections/HcoIdsSection/HcoIdsSection';
import { HcoNameSection } from '../../Sections/HcoSections/HcoNameSection/HcoNameSection';
import { HcoOrganizationalSection } from '../../Sections/HcoSections/OrganizationalSection/HcoOrganizationalSection';

import { hcoDcrModalContentStyles } from './HcoDcrModalContent.styles';

export const HcoDcrModalContent = () => {
	const { t } = useTranslation();

	return (
		<Box sx={hcoDcrModalContentStyles.root}>
			<HcoNameSection />
			<HcoOrganizationalSection />
			<HcoIdsSection />
			<ContactSection entityType={EntityType.Hco} />
			{/* <SpecialtiesSection entityType={EntityType.Hco} /> */}
			{/* Note: Hierarchy section hidden pre-launch — type_of_hierarchy not yet supported */}
			{/* <HierarchySection entityType={EntityType.Hco} /> */}
			<AffiliationsSection
				label={t('Parent HCOs')}
				entityType={EntityType.Hco}
				fieldName='parenthcos'
				sectionId='affiliations'
				includeRelationshipTypeIds={[OWNSO_RELATIONSHIP_TYPE_ID]}
			/>
			<AddressSection />
		</Box>
	);
};
